import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type CreateGroupChatRequest = {
  eventId: string;
};

export type CreateGroupChatResponse = Chat;

export const createGroupChat = async (body: CreateGroupChatRequest): Promise<CreateGroupChatResponse> => {
  const { data } = await axios.post(`/chats/group/start`, body);

  return data;
};
